<template>
  <v-card min-height="400">
    <vue-card-title
      :title="'Manage Users from ' + selectedOrganization.name"
      :subtitle="'Refer to the following information managing the crm users.'"
      :icon="$getIcon('mdiFileDocumentEdit')"
    >
      <template slot="actions">
        <v-btn
          class="indigo accent-2 white--text text-capitalize my-0"
          small
          @click="crmAddUserForm = true"
        >
          Add CRM User
        </v-btn>
      </template>
    </vue-card-title>
    <v-divider></v-divider>
    <v-card-text>
      <v-row v-if="!fetched">
        <v-col md="12">
          <vue-default-svg-loader></vue-default-svg-loader>
        </v-col>
      </v-row>
      <v-row v-else>
        <v-col md="10">
          <vue-pagination-component
            :fetch-api.sync="fetchAPI"
            :search-label="searchLabel"
            :query-params.sync="queryParams"
            :filter-query="queryParams"
            :next-link="nextLink"
            :previous-link="previousLink"
            :pagination-info="paginationInfo"
          ></vue-pagination-component>
        </v-col>
        <v-col md="2">
          <v-select
            v-model="filter"
            :items="filterItems"
            label="Filters"
            item-text="name"
            item-value="value"
          ></v-select>
        </v-col>
        <v-col v-if="fetchedData.length < 1 && filtered" md="12">
          Search results not found.
        </v-col>
        <v-col v-else-if="fetchedData.length < 1" md="12">
          <vue-no-data></vue-no-data>
        </v-col>
        <v-col
          v-for="(crmUser, index) in fetchedData"
          v-else
          :key="index"
          md="4"
        >
          <crm-user-card
            :crm-user-data="crmUser"
            editable
            @crmUpdateFormSuccess="formSuccess"
          >
          </crm-user-card>
        </v-col>
      </v-row>
    </v-card-text>
    <!-- CRM Add User Form -->
    <v-bottom-sheet v-model="crmAddUserForm" scrollable>
      <v-card tile>
        <vue-card-title
          :title="`Add CRM User/s`"
          :subtitle="'Fill up the following form to add crm user/s.'"
          :icon="$getIcon('mdiFileDocumentEdit')"
        >
        </vue-card-title>
        <v-divider></v-divider>
        <v-card-text>
          <crm-add-user-form
            v-if="crmAddUserForm"
            :form-status="crmAddUserForm"
            :org-slug="orgSlug"
            @crmUserFormResponse="formSuccess"
          >
          </crm-add-user-form>
        </v-card-text>
      </v-card>
    </v-bottom-sheet>
    <!-- / CRM Add User Form -->
  </v-card>
</template>
<script>
import PaginationMixin from "@/mixins/paginationSearchMixin";
import CrmUserCard from "@/components/crm/crm_user/CrmUserCard";
import CrmAddUserForm from "@/components/crm/crm_user/forms/CrmAddUserForm";

export default {
  components: {
    CrmUserCard,
    CrmAddUserForm
  },
  mixins: [PaginationMixin],
  data() {
    return {
      // paginationMixin
      fetchAPI:
        "/api/v1/users/?organization__slug=" + this.$route.params.orgSlug,
      searchLabel: "Search for crm user",
      // crm add user form
      crmAddUserForm: false,
      orgSlug: this.$route.params.orgSlug,
      filterItems: [
        {
          name: "All",
          value: "all"
        },
        {
          name: "View Admins",
          value: "admins"
        },
        {
          name: "View Deal Verifiers",
          value: "deal_verifier"
        }
      ],
      filter: "all"
    };
  },
  computed: {
    crmUserOrganizations() {
      return this.$store.state.auth.user.scoped_organizations;
    },
    selectedOrganization() {
      return this.crmUserOrganizations.find(x => x.slug === this.orgSlug);
    }
  },
  watch: {
    filter(val) {
      if (val === "admins") {
        this.queryParams.is_admin = true;
      } else if (val === "all") {
        this.queryParams = {};
      } else {
        this.queryParams.deal_verifier = true;
      }
      this.fetchData();
    }
  },
  methods: {
    formSuccess() {
      this.crmAddUserForm = false;
      this.fetchData();
    }
  }
};
</script>
